import React from "react";
import { useLocation, matchPath, useNavigate } from "react-router-dom";
import FiberNewIcon from '@mui/icons-material/FiberNew';
import { Grid, Container, Box, Typography, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import AppsIcon from "@mui/icons-material/Apps";
import CloseIcon from "@mui/icons-material/Close";
import { SiteRouterLink } from "../../components/RouterLink";
import { useI18n } from "@haohan/root-locales";
import { makeStyles } from 'tss-react/mui';
import { locales, useMenu } from "./config";
import { SiteHeaderLanguages } from "./Languages";
import { AccountButton } from "./ AccountButton";

const useStyles = makeStyles({name: "AppHeader"})(theme => ({
	header: {
		position: "relative",
		// boxShadow: "0 9px 14px -5px rgba(0, 0, 0, .10)",
		// background: theme.palette.background.paper,
		width: '100%',
		overflow: 'hidden'
	},
	topBar: {
	//	backgroundColor: theme.palette.background.default
	},
	topNav: {
		display: 'flex',
		alignItems: 'center',
		height: '3.5rem',
	},
	logo: {
		display: 'flex',
        flexWrap: 'nowrap',
        textDecoration: 'none',
        alignItems: 'center',
		'& img': {
			display: 'block',
			height: '100%',
		}
	},
	menuItem: {
		display: 'block',
		boxSizing: 'border-box',
		fontSize: '.8rem',
		fontWeight: 500,
		textTransform: 'uppercase',
		color: theme.palette.text.secondary,
		cursor: 'pointer',
		whiteSpace: 'nowrap',

		'&:hover': {
			color: theme.palette.text.primary,
			opacity: .8,
		}
	},
	menuItemActive: {
		color: theme.palette.primary.dark,
	},
	searchInputWrapper: {
		maxWidth: 400,
		width: '100%',
	},
	flagItem: {
		width: 28,
		height: 28,
		borderRadius: "50%",
		overflow: "hidden",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		boxShadow: theme.shadows[3],
		boxSizing: "border-box",
		cursor: "pointer",
		backgroundClip: "content-box",
		backgroundSize: "cover",
		border: `1px solid transparent`,
		backgroundPosition: "center center",
		opacity: .2,
		margin: "0 4px",
	},
	flagItemActive: {
		opacity: 1,
		padding: 1,
		borderColor: theme.palette.primary.light
	}
}));

export function SiteMobileHeader() {
	const { classes, cx } = useStyles();
    const [menuOpen, setMenuOpen] = React.useState(false);
	const { t, lang } = useI18n();
	const location = useLocation();
	const locationUrl = (newLang: string) => {
		const newPathname = location.pathname.replace(
			new RegExp(`^/${lang}(.*)`),
			`/${newLang}$1`
		);

		return `${newPathname}${location.search}`;
	}
	
    const navigate = useNavigate();
	const menu = useMenu(t, lang);
	return (
		<>
            <Drawer
                variant='temporary'
                open={menuOpen}
                onClose={() => setMenuOpen(false)}
            >
                <Box px={2} pt={2} mb={3}>
                    <CloseIcon onClick={() => setMenuOpen(false)}/>
                </Box>
                <Box minWidth={220}>
                    <List>
                        {menu.map((item, idx) => {
                            return (
                                <ListItemButton
                                    key={idx}
                                    onClick={() => {
                                        navigate(`/${lang}/${item.path}`);
                                        setMenuOpen(false);
                                    }}
                                >
									<ListItemText>
                                    	{item.label}
									</ListItemText>
									{item.new && (
										<ListItemIcon style={{ minWidth: 0 }}>
											<FiberNewIcon color='primary' />
										</ListItemIcon>
									)}
                                </ListItemButton>
                            );
                        })}
                    </List>
                </Box>
                <Box mt='auto' p={2}>
                    <SiteHeaderLanguages />
                </Box>
            </Drawer>
			<Box
                px={2}
                py={1}
                display='flex'
                flexWrap='nowrap'
                alignItems='center'
            >
                <Box display='flex'>
                    <AppsIcon
                        onClick={() => setMenuOpen(true)}
                        fontSize='large'
                    />
                </Box>
                <Box ml={1} mt={-.5}>
                    <SiteRouterLink className={cx(classes.logo)} to="/">
                        <img
                            alt="Haohan logo"
                            width={30}
                            height={30}
                            src="/dist/img/logo.svg"
                        />
                    </SiteRouterLink>
                </Box>
				<Box flex={1} display='flex' justifyContent='flex-end'>
					<AccountButton />
				</Box>
			</Box>
		</>
	);
}
